export const SORT_DIR = {
  ASC: "asc",
  DESC: "desc",
  DEFAULT: undefined
};

function sort(arr, direction, options) {
  const { sortBy = (v) => v, collatorLang = "en", collatorOptions = {} } =
    options || {};

  if (!Array.isArray(arr) || !direction) return arr;
  const intlStringCompare = new Intl.Collator(collatorLang, {
    sensitivity: "base",
    ...collatorOptions
  }).compare;
  // clone arr into newArr to prevent sort from changing the original value
  const newArr = arr.slice(0);
  const factor = direction === SORT_DIR.DESC ? -1 : 1;
  newArr.sort((a, b) => {
    let result;
    const aVal = sortBy(a);
    const bVal = sortBy(b);
    if (typeof aVal === "string" && typeof bVal === "string") {
      result = intlStringCompare(aVal, bVal);
    } else {
      if (aVal === bVal) result = 0;
      else if (aVal === undefined || (aVal === null && bVal !== undefined))
        result = -1;
      else if (bVal === undefined || bVal === null) result = 1;
      else result = aVal < bVal ? -1 : 1;
    }
    return result !== 0 ? factor * result : result;
  });
  return newArr;
}

export default sort;
